export default __webpack_public_path__ + "static/media/ProximaNova-Bold.fcaab252.otf";